import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/layout/NavBar";
import Footer from "../components/layout/Footer";

export default function CGS() {
  return (
    <main className="min-h-screen bg-white text-gray-900 pt-20">
      <NavBar />

      <section className="px-6 pt-10 pb-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-semibold leading-tight">Conditions Générales de Services</h1>
          <p className="mt-3 text-sm text-gray-500">En vigueur au 10/08/2025</p>
        </div>
      </section>

      <section className="px-6 pb-24">
        <div className="max-w-3xl mx-auto space-y-10 text-[15px] leading-7 text-gray-800">

          {/* Préambule */}
          <div>
            <p>
              Les présentes Conditions Générales de Services (ci-après « CGS ») ont pour objet de définir les
              modalités d'exécution des prestations réalisées par la société{" "}
              <span className="font-medium">NOXZI</span>, SASU au capital de 100,00 €, immatriculée au RCS de
              Chambéry sous le n° 990 027 377, dont le siège social est situé 792 Chemin de Charrière Neuve,
              73000 Chambéry, France (ci-après « NOXZI » ou « le Prestataire »), au bénéfice de tout client
              professionnel ou particulier (ci-après « le Client »).
            </p>
            <p className="mt-3">
              Les CGS complètent les Conditions Générales de Vente (CGV) de NOXZI et s'appliquent à l'ensemble
              des prestations dès lors qu'un devis est signé par le Client. En cas de contradiction entre les
              CGS et les CGV, les CGV prévalent. En cas de contradiction entre les CGS et le devis, les
              stipulations du devis prévalent.
            </p>
            <p className="mt-3">
              La signature du devis emporte acceptation pleine et entière des présentes CGS.
            </p>
          </div>

          {/* Art. 1 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 1 — Identification du Prestataire</h2>
            <ul className="mt-3 space-y-1 list-none pl-0">
              <li><span className="font-medium">Société :</span> NOXZI, SASU au capital de 100,00 €</li>
              <li><span className="font-medium">Siège social :</span> 792 Chemin de Charrière Neuve, 73000 Chambéry, France</li>
              <li><span className="font-medium">RCS :</span> Chambéry — SIREN 990 027 377</li>
              <li><span className="font-medium">Responsable :</span> Lionel FAURE</li>
              <li><span className="font-medium">Téléphone :</span> +33 (0)6 03 59 99 52</li>
              <li><span className="font-medium">E-mail :</span>{" "}
                <a href="mailto:contact@noxzi.fr" className="underline">contact@noxzi.fr</a>
              </li>
            </ul>
            <p className="mt-3">
              L'ensemble des prestations est réalisé directement par NOXZI, sans recours à la sous-traitance.
              NOXZI garantit que les intervenants disposent des compétences nécessaires à la bonne exécution
              des missions confiées.
            </p>
          </section>

          {/* Art. 2 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 2 — Description des services</h2>

            <h3 className="font-medium mt-4 mb-2">2.1 Création de sites internet</h3>
            <p>
              NOXZI assure la conception et le développement de sites internet sur mesure (sites vitrine,
              e-commerce, landing pages, applications web). La prestation comprend les phases suivantes, dont
              le périmètre précis est défini au devis :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>Recueil du cahier des charges et analyse des besoins du Client ;</li>
              <li>Conception des maquettes graphiques (wireframes et/ou design haute fidélité) ;</li>
              <li>Développement technique (front-end, back-end, intégration CMS le cas échéant) ;</li>
              <li>Intégration des contenus fournis par le Client ;</li>
              <li>Phase de recette et corrections suite aux retours du Client ;</li>
              <li>Mise en ligne et tests de bon fonctionnement ;</li>
              <li>Formation à la prise en main si prévue au devis.</li>
            </ul>
            <p className="mt-3">
              Les hébergement et nom de domaine ne sont pas inclus dans la prestation sauf mention expresse
              au devis. Le Client est responsable du renouvellement de son nom de domaine et du paiement
              de son hébergement.
            </p>

            <h3 className="font-medium mt-4 mb-2">2.2 Développement d'applications mobiles</h3>
            <p>
              NOXZI assure la conception et le développement d'applications mobiles iOS et/ou Android,
              natives ou hybrides. La prestation comprend :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>Recueil du cahier des charges, définition des fonctionnalités et des parcours utilisateurs ;</li>
              <li>Conception des maquettes et prototypes interactifs ;</li>
              <li>Développement technique et intégration des API nécessaires ;</li>
              <li>Phase de tests et corrections ;</li>
              <li>Accompagnement à la publication sur les stores (App Store, Google Play) si prévu au devis.</li>
            </ul>
            <p className="mt-3">
              Les comptes développeur Apple et Google, les frais d'inscription aux stores ainsi que les
              éventuels services tiers (push notifications, paiement in-app, etc.) sont à la charge du Client,
              sauf mention contraire au devis.
            </p>

            <h3 className="font-medium mt-4 mb-2">2.3 Maintenance mensuelle</h3>
            <p>
              Le service de maintenance comprend, selon la formule souscrite au devis :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>Mises à jour régulières du CMS, des thèmes, plugins et librairies ;</li>
              <li>Surveillance de la disponibilité du site ;</li>
              <li>Sauvegardes périodiques ;</li>
              <li>Corrections de bugs et interventions correctives dans la limite du volume d'heures mensuel défini au devis ;</li>
              <li>Rapport mensuel de maintenance transmis au Client.</li>
            </ul>
            <p className="mt-3">
              Toute intervention dépassant le volume d'heures inclus dans la formule sera soumise à un devis
              complémentaire ou facturée au taux horaire en vigueur communiqué au Client.
            </p>

            <h3 className="font-medium mt-4 mb-2">2.4 Gestion des réseaux sociaux</h3>
            <p>
              Le service de gestion des réseaux sociaux comprend, selon la formule souscrite au devis :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>Audit et optimisation des profils et pages existants ;</li>
              <li>Élaboration d'un calendrier éditorial mensuel soumis à validation du Client ;</li>
              <li>Création des visuels et rédaction des légendes et hashtags ;</li>
              <li>Programmation et publication des contenus selon le calendrier validé ;</li>
              <li>Modération de base (réponses aux commentaires selon accord préalable) ;</li>
              <li>Reporting mensuel des statistiques (portée, engagement, abonnés).</li>
            </ul>
            <p className="mt-3">
              La gestion des campagnes publicitaires payantes (Meta Ads, TikTok Ads, etc.) est une prestation
              distincte, non incluse dans cet abonnement sauf mention expresse au devis. Les budgets publicitaires
              sont avancés par le Client directement sur les plateformes concernées.
            </p>

            <h3 className="font-medium mt-4 mb-2">2.5 Gestion Google Business Profile</h3>
            <p>
              Le service de gestion Google Business Profile comprend :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>Création ou revendication et vérification de la fiche Google ;</li>
              <li>Optimisation complète des informations (catégories, description, horaires, photos, attributs) ;</li>
              <li>Publication de posts réguliers (actualités, offres, événements) ;</li>
              <li>Surveillance et réponse aux avis clients (sous validation du Client pour les réponses) ;</li>
              <li>Reporting mensuel des statistiques (vues, clics, appels générés).</li>
            </ul>
            <p className="mt-3">
              NOXZI ne peut garantir un positionnement spécifique dans les résultats Google, celui-ci étant
              déterminé par les algorithmes de Google indépendamment de la volonté de NOXZI.
            </p>
          </section>

          {/* Art. 3 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 3 — Processus de collaboration et outils</h2>

            <h3 className="font-medium mt-4 mb-2">3.1 Interlocuteurs</h3>
            <p>
              Dès la signature du devis, NOXZI désigne un interlocuteur référent pour le Client. Le Client
              s'engage de son côté à désigner un interlocuteur unique, disponible et habilité à valider les
              livrables et à prendre les décisions nécessaires au bon déroulement de la mission.
            </p>

            <h3 className="font-medium mt-4 mb-2">3.2 Outils de travail collaboratif</h3>
            <p>
              Pour faciliter le suivi des projets et la communication, NOXZI utilise des outils tiers
              collaboratifs, notamment :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li><span className="font-medium">Notion</span> : partage de documents de travail, briefs, cahiers des charges, calendriers éditoriaux ;</li>
              <li><span className="font-medium">Google Drive</span> : stockage et partage des livrables, visuels, fichiers sources et reportings ;</li>
              <li>Tout autre outil convenu d'un commun accord avec le Client.</li>
            </ul>
            <p className="mt-3">
              L'utilisation de ces outils est soumise aux conditions générales et politiques de confidentialité
              propres à chaque plateforme. NOXZI s'assure de ne partager via ces outils que les données
              strictement nécessaires à l'exécution de la mission. Le Client accepte l'utilisation de ces
              outils en signant le devis.
            </p>
            <p className="mt-3">
              NOXZI ne saurait être tenue responsable d'une indisponibilité, d'une panne ou d'une perte de
              données imputable à l'un de ces outils tiers. Dans la mesure du possible, les livrables finaux
              sont également transmis au Client par e-mail ou via un canal de substitution.
            </p>

            <h3 className="font-medium mt-4 mb-2">3.3 Communication</h3>
            <p>
              Les échanges relatifs aux projets se font principalement par e-mail et via les outils collaboratifs
              mentionnés ci-dessus. NOXZI s'engage à répondre aux sollicitations du Client dans un délai de{" "}
              <span className="font-medium">2 jours ouvrés</span>. En dehors des heures ouvrées (lundi au
              vendredi, 9h–18h), les demandes seront traitées le prochain jour ouvré.
            </p>

            <h3 className="font-medium mt-4 mb-2">3.4 Réunions et points de suivi</h3>
            <p>
              Des points de suivi réguliers peuvent être organisés selon la nature et la durée du projet,
              en présentiel ou à distance (visioconférence). Les modalités sont définies au démarrage de la
              mission. Toute réunion non prévue au devis et dépassant le cadre normal du suivi de projet
              pourra être facturée au temps passé.
            </p>
          </section>

          {/* Art. 4 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 4 — Livrables et validation</h2>

            <h3 className="font-medium mt-4 mb-2">4.1 Nature des livrables</h3>
            <p>
              Les livrables fournis par NOXZI sont définis dans le devis. Ils peuvent inclure, selon la
              prestation : maquettes graphiques, fichiers sources, code source, accès à l'environnement de
              développement, visuels pour les réseaux sociaux, calendriers éditoriaux, reportings mensuels.
            </p>

            <h3 className="font-medium mt-4 mb-2">4.2 Procédure de validation</h3>
            <p>
              Chaque livrable est soumis au Client pour validation. Le Client dispose des délais suivants
              pour formuler ses retours par écrit :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>
                <span className="font-medium">Projets site / application :</span> 15 jours ouvrés à compter
                de la réception du livrable ;
              </li>
              <li>
                <span className="font-medium">Contenus réseaux sociaux / Google :</span> 48 heures ouvrées
                à compter de la soumission.
              </li>
            </ul>
            <p className="mt-3">
              Passé ces délais sans retour écrit du Client, les livrables sont réputés validés et acceptés
              tacitement. NOXZI ne pourra être tenue responsable des conséquences d'un contenu publié ou
              mis en ligne suite à cette validation tacite.
            </p>

            <h3 className="font-medium mt-4 mb-2">4.3 Nombre d'allers-retours</h3>
            <p>
              Sauf mention contraire au devis, chaque livrable donne droit à{" "}
              <span className="font-medium">2 cycles de corrections</span> inclus. Au-delà, les modifications
              supplémentaires seront facturées au taux horaire en vigueur ou feront l'objet d'un avenant.
            </p>
            <p className="mt-3">
              Constitue une modification incluse : toute demande de correction conforme au cahier des charges
              initial. Constitue une modification facturée en supplément : tout changement de direction
              créative, ajout de fonctionnalité ou demande ne figurant pas dans le cahier des charges initial.
            </p>
          </section>

          {/* Art. 5 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 5 — Obligations de NOXZI</h2>
            <p>NOXZI s'engage à :</p>
            <ul className="mt-3 ml-5 list-disc space-y-2">
              <li>
                Exécuter les prestations avec soin, diligence et professionnalisme, conformément aux règles
                de l'art en vigueur dans le secteur du numérique ;
              </li>
              <li>
                Respecter la confidentialité des informations transmises par le Client (voir article 8) ;
              </li>
              <li>
                Informer proactivement le Client de tout événement susceptible d'affecter le bon déroulement
                de la mission, notamment tout retard prévisible ;
              </li>
              <li>
                Mettre à disposition du Client les livrables convenus dans les délais définis au devis ;
              </li>
              <li>
                Assurer une veille sur les évolutions techniques et réglementaires susceptibles d'impacter
                les prestations en cours ;
              </li>
              <li>
                Conserver les fichiers sources et livrables liés aux projets réalisés pendant une durée
                minimum de <span className="font-medium">12 mois</span> après la livraison définitive.
              </li>
            </ul>
          </section>

          {/* Art. 6 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 6 — Obligations du Client</h2>
            <p>Le Client s'engage à :</p>
            <ul className="mt-3 ml-5 list-disc space-y-2">
              <li>
                Fournir à NOXZI, dans les délais convenus, l'ensemble des informations, contenus et accès
                nécessaires (textes, images, logos, identifiants, accès serveur, etc.) ;
              </li>
              <li>
                S'assurer de l'exactitude et de l'exhaustivité des informations transmises et disposer de
                tous les droits nécessaires sur ces éléments ;
              </li>
              <li>
                Désigner un interlocuteur unique disponible, en mesure de valider les livrables et de
                prendre les décisions nécessaires sans délai excessif ;
              </li>
              <li>
                Respecter les délais de validation définis à l'article 4 ;
              </li>
              <li>
                Ne pas modifier ou faire modifier par un tiers les livrables remis par NOXZI sans accord
                préalable, sous peine de perdre le bénéfice des garanties ;
              </li>
              <li>
                Pour les abonnements de gestion de réseaux sociaux et Google Business Profile, ne pas
                procéder à des modifications directes sur les comptes gérés par NOXZI sans en informer
                préalablement le Prestataire.
              </li>
            </ul>
          </section>

          {/* Art. 7 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 7 — Niveaux de service et disponibilité</h2>

            <h3 className="font-medium mt-4 mb-2">7.1 Heures ouvrées</h3>
            <p>
              NOXZI intervient du lundi au vendredi de 9h à 18h, hors jours fériés. Toute demande reçue en
              dehors de ces horaires sera prise en charge le prochain jour ouvré.
            </p>

            <h3 className="font-medium mt-4 mb-2">7.2 Délais d'intervention — Maintenance</h3>
            <p>
              Dans le cadre des contrats de maintenance, les délais d'intervention suivants s'appliquent,
              à compter de la réception de la demande du Client durant les heures ouvrées :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>
                <span className="font-medium">Incident critique</span> (site inaccessible, faille de sécurité
                avérée) : prise en charge sous <span className="font-medium">4 heures ouvrées</span>, résolution
                dans les meilleurs délais ;
              </li>
              <li>
                <span className="font-medium">Incident majeur</span> (fonctionnalité principale hors service) :
                prise en charge sous <span className="font-medium">1 jour ouvré</span> ;
              </li>
              <li>
                <span className="font-medium">Incident mineur</span> (dysfonctionnement non bloquant) : prise en
                charge sous <span className="font-medium">3 jours ouvrés</span>.
              </li>
            </ul>
            <p className="mt-3">
              Ces délais constituent des engagements de moyens et non de résultat. Ils s'appliquent sous
              réserve que les accès nécessaires aient été transmis par le Client.
            </p>

            <h3 className="font-medium mt-4 mb-2">7.3 Urgences hors maintenance</h3>
            <p>
              Pour les Clients ne disposant pas d'un contrat de maintenance, les interventions urgentes
              pourront être réalisées sous réserve de disponibilité de NOXZI et seront facturées au taux
              horaire majoré applicable aux interventions non planifiées, communiqué au Client avant toute
              intervention.
            </p>
          </section>

          {/* Art. 8 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 8 — Confidentialité et protection des données</h2>

            <h3 className="font-medium mt-4 mb-2">8.1 Confidentialité</h3>
            <p>
              NOXZI s'engage à traiter comme strictement confidentiels l'ensemble des informations,
              documents, données techniques et commerciales communiqués par le Client dans le cadre de
              l'exécution des prestations. Cette obligation s'applique pendant toute la durée du contrat
              et pour une période de <span className="font-medium">3 ans</span> après son terme.
            </p>
            <p className="mt-3">
              Cette obligation ne s'applique pas aux informations déjà publiques, indépendamment de toute
              action de NOXZI, ou dont la divulgation est imposée par la loi ou une décision judiciaire.
            </p>

            <h3 className="font-medium mt-4 mb-2">8.2 Données personnelles</h3>
            <p>
              Dans le cadre des prestations, NOXZI peut être amenée à accéder à des données personnelles
              appartenant au Client ou à ses propres clients (notamment lors de la gestion de comptes sur
              les réseaux sociaux ou de la maintenance de sites avec base de données utilisateurs).
            </p>
            <p className="mt-3">
              Dans ce cas, NOXZI agit en qualité de <span className="font-medium">sous-traitant</span> au
              sens du RGPD et s'engage à traiter ces données uniquement sur instruction documentée du
              Client (responsable de traitement), à mettre en œuvre les mesures de sécurité appropriées
              et à ne pas les transférer à des tiers non autorisés. Si la nature des prestations l'exige,
              un accord de traitement des données (DPA) pourra être établi entre les parties.
            </p>

            <h3 className="font-medium mt-4 mb-2">8.3 Sécurité des accès</h3>
            <p>
              Le Client s'engage à transmettre les identifiants et mots de passe nécessaires de manière
              sécurisée (via un gestionnaire de mots de passe ou un canal chiffré). NOXZI s'engage à ne
              pas stocker ces accès de manière non sécurisée et à les restituer ou supprimer à la fin du
              contrat.
            </p>
          </section>

          {/* Art. 9 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 9 — Propriété des livrables et cession de droits</h2>
            <p>
              L'ensemble des créations réalisées par NOXZI dans le cadre des prestations (designs, code,
              visuels, contenus textuels) demeure la propriété intellectuelle de NOXZI jusqu'au paiement
              intégral de la prestation.
            </p>
            <p className="mt-3">
              Après paiement intégral, NOXZI cède au Client les droits d'exploitation sur les livrables
              finaux, pour une utilisation dans le cadre normal de son activité, de manière non exclusive
              et sans limitation de durée. Les codes sources, fichiers sources graphiques et éléments
              constitutifs des livrables sont transmis au Client si cela est prévu au devis.
            </p>
            <p className="mt-3">
              Cette cession ne porte pas sur les outils, frameworks, librairies open-source, plugins ou
              méthodes de travail propriétaires utilisés par NOXZI, qui restent sa propriété exclusive ou
              sont régis par leurs licences propres.
            </p>
            <p className="mt-3">
              Sauf opposition écrite du Client avant le démarrage de la prestation, NOXZI se réserve le
              droit de mentionner la réalisation à titre de référence commerciale (portfolio, site internet,
              réseaux sociaux de NOXZI).
            </p>
          </section>

          {/* Art. 10 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 10 — Garanties</h2>

            <h3 className="font-medium mt-4 mb-2">10.1 Garantie après livraison — Sites et applications</h3>
            <p>
              À compter de la livraison définitive acceptée par le Client, NOXZI garantit les livrables
              contre tout dysfonctionnement technique directement imputable à une erreur de développement,
              pendant une durée de <span className="font-medium">30 jours calendaires</span>. Durant cette
              période, les corrections sont réalisées sans frais supplémentaires.
            </p>
            <p className="mt-3">
              Cette garantie ne couvre pas les dysfonctionnements résultant d'une modification du livrable
              par le Client ou un tiers, d'une incompatibilité avec un environnement non testé, d'une mise
              à jour réalisée par le Client sans accord de NOXZI, ou de tout événement extérieur (panne
              d'hébergeur, cyberattaque, etc.).
            </p>

            <h3 className="font-medium mt-4 mb-2">10.2 Absence de garantie de résultat</h3>
            <p>
              NOXZI est tenue à une obligation de moyens pour l'ensemble de ses prestations. Elle ne peut
              garantir de résultats commerciaux spécifiques, notamment en termes de référencement naturel
              (SEO), de taux de conversion, d'engagement sur les réseaux sociaux ou de génération de leads,
              ces résultats dépendant de facteurs extérieurs à son contrôle.
            </p>
          </section>

          {/* Art. 11 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 11 — Fin de prestation et restitution</h2>
            <p>
              À la fin de toute prestation ou en cas de résiliation du contrat, NOXZI s'engage à :
            </p>
            <ul className="mt-3 ml-5 list-disc space-y-2">
              <li>
                Restituer au Client l'ensemble des accès (hébergement, CMS, comptes réseaux sociaux, Google
                Business, outils collaboratifs) fournis par le Client ou créés pour son compte ;
              </li>
              <li>
                Transmettre les fichiers sources et livrables finaux si cela est prévu au devis et que le
                paiement intégral a été effectué ;
              </li>
              <li>
                Supprimer de ses systèmes les données confidentielles du Client dans un délai de{" "}
                <span className="font-medium">30 jours</span> suivant la fin du contrat, sauf obligation
                légale de conservation.
              </li>
            </ul>
            <p className="mt-3">
              Le Client reste seul propriétaire de ses comptes, pages, fiches et données, quelles que soient
              les circonstances de la fin du contrat.
            </p>
          </section>

          {/* Art. 12 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 12 — Modification des CGS</h2>
            <p>
              NOXZI se réserve le droit de modifier les présentes CGS à tout moment. Les modifications
              entrent en vigueur dès leur publication sur le Site. Pour les contrats en cours, les nouvelles
              CGS s'appliquent à compter du renouvellement suivant leur publication, après information
              préalable du Client par e-mail dans un délai raisonnable.
            </p>
          </section>

          {/* Art. 13 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 13 — Droit applicable et règlement des litiges</h2>
            <p>
              Les présentes CGS sont régies par le droit français. En cas de litige, les parties s'engagent
              à rechercher une solution amiable dans un délai de 30 jours à compter de la notification du
              différend.
            </p>
            <p className="mt-3">
              Pour les clients particuliers (B2C) : en cas d'échec de la tentative amiable, le Client peut
              recourir gratuitement à un médiateur de la consommation (art. L. 611-1 Code de la consommation).
              Coordonnées du médiateur sur demande à{" "}
              <a href="mailto:contact@noxzi.fr" className="underline">contact@noxzi.fr</a>. Plateforme
              européenne de résolution en ligne :{" "}
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" className="underline">
                ec.europa.eu/consumers/odr
              </a>.
            </p>
            <p className="mt-3">
              Pour les clients professionnels (B2B) : à défaut d'accord amiable, tout litige sera soumis à
              la compétence exclusive des tribunaux du ressort de{" "}
              <span className="font-medium">Chambéry</span>, même en cas de pluralité de défendeurs ou
              d'appel en garantie.
            </p>
          </section>

        </div>
      </section>

      <Footer />
    </main>
  );
}